//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ProductAttributes',
  components: {
    ProductAttribute: () => import('@motionelements/catalog/src/modules/product/element/details/ElementAttribute.vue'),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      schema: state => state.product.elementSchema,
    }),
    ...mapGetters({
      mediaType: 'product/mediaType',
      masterVariant: 'product/masterVariant',
    }),
    productAttributesMap() {
      switch (this.mediaType) {
        case 'photo':
        case 'gif':
          return [
            'dimension', 'alpha', 'license',
            'modelRelease', 'propertyRelease', 'location', 'source',
          ];
        case 'photo_vr':
          return [
            'projection', 'viewingField', 'resolution', 'fileSize',
            'modelRelease', 'propertyRelease', 'location', 'source', 'rendering',
          ];
        case 'vector':
          return ['license', 'source'];
        case 'video_live':
        case 'animation':
          return [
            'loop', 'duration', 'aspectRatio', 'alpha', 'fps', 'license',
            'modelRelease', 'propertyRelease', 'location', 'source', 'rendering',
          ];
        case 'video_vr':
          return [
            'duration', 'resolution', 'fileSize', 'projection', 'viewingField',
            'license', 'modelRelease', 'propertyRelease', 'location', 'source',
            'rendering',
          ];
        case '3d_model':
          return [
            'geometry', 'vertices', 'polygons', 'rigged', 'animated',
            'license', 'source', 'rendering',
          ];
        case 'music':
          return [
            'editType', 'loop', 'duration', 'bpm', 'musicalKey', 'audioCodec',
            'audioBitDepth', 'audioSampleRate', 'audioChannels', 'fileSize', 'license',
            'youtubeContentId', 'allowMusicalWorks', 'composers', 'publishers', 'source',
          ];
        case 'sfx':
          return [
            'duration', 'audioCodec', 'audioBitDepth', 'audioSampleRate',
            'audioChannels', 'fileSize', 'license', 'source',
          ];
        case 'ae_template':
          return [
            'softwareRequired', 'pluginsRequired', 'durations', 'dimensions', 'fileSize',
            // specific to ae
            'universalized', 'expression', 'composition', 'license', 'textPlaceholders',
            'videoPlaceholders', 'logoPlaceholders', 'hasMusic', 'hasSfx', 'hasVideo',
          ];
        case 'motion_template':
          return [
            'softwareRequired', 'pluginsRequired', 'durations', 'dimensions', 'fileSize',
            // specific to motion
            'editableInFcp', 'license', 'textPlaceholders', 'videoPlaceholders',
            'logoPlaceholders', 'hasMusic', 'hasSfx', 'hasVideo',
          ];
        case 'pr_template':
        case 'mg_template':
        case 'resolve_template':
          return [
            'softwareRequired', 'pluginsRequired', 'durations', 'dimensions', 'fileSize',
            'license', 'textPlaceholders', 'videoPlaceholders', 'logoPlaceholders',
            'hasMusic', 'hasSfx', 'hasVideo',
          ];
        case 'ae_preset':
        case 'pr_preset':
        case 'resolve_macro':
          return ['softwareRequired', 'fileSize', 'license'];
        case 'lottie':
          return [
            'softwareRequired', 'dimensions', 'background', 'license',
            'format', 'jsonFileSize', 'source', 'rendering',
          ];
        // others
        case 'graphic_template':
        case 'ui_template':
          return [
            'compatibleApplications', 'fileTypeIncluded', 'dimensions',
            'orientation', 'colorSpace', 'layered', 'vector', 'license',
          ];
        case 'presentation_template':
          return ['compatibleApplications', 'fileTypeIncluded', 'size', 'license'];
        case 'notion_template':
          return ['license'];
        // prompt
        case 'midjourney_prompt':
          return ['softwareRequired', 'wordCount', 'placeholders', 'license'];
        case 'image_prompt':
          return ['aiGenerator', 'aiModel', 'wordCount', 'placeholders', 'license'];
        default:
          return [];
      }
    },
    productAttributes() {
      const fields = {};
      _.intersection(this.productAttributesMap, _.keys(this.schema)).forEach((key) => {
        fields[key] = this.schema[key];
      });
      return fields;
    },
  },
};
